var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSchool = function SvgIconSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-school_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-school_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M4.5 14.625a1.244 1.244 0 0 1-.562-.542 1.606 1.606 0 0 1-.209-.791V9.25L1.563 8.167a.734.734 0 0 1-.313-.28.743.743 0 0 1-.104-.387c0-.142.035-.272.104-.388a.734.734 0 0 1 .313-.279l7-3.5a1.444 1.444 0 0 1 .666-.166 1.405 1.405 0 0 1 .667.166l7.937 3.959c.125.07.223.161.292.275a.7.7 0 0 1 .104.37v5.313a.718.718 0 0 1-.229.52.729.729 0 0 1-.531.23.696.696 0 0 1-.521-.23.734.734 0 0 1-.219-.52v-5l-2 1v4.042c0 .277-.066.538-.198.78a1.296 1.296 0 0 1-.573.553l-4.062 2.042a1.28 1.28 0 0 1-.33.114 1.763 1.763 0 0 1-.67 0 1.271 1.271 0 0 1-.333-.114L4.5 14.625Zm4.73-4.313L14.874 7.5 9.229 4.688 3.583 7.5l5.646 2.813Zm0 4.98 4-1.98v-3.291l-3.272 1.625a1.415 1.415 0 0 1-.729.187c-.139 0-.267-.014-.385-.041a1.138 1.138 0 0 1-.344-.146L5.23 10.02v3.291l4 1.98Z"
  }))));
};
export default SvgIconSchool;